import { useNavigate } from "react-router-dom";
import { Minus, Plus, ShoppingBag, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { brl } from "@/lib/format";

export const CartSheet = ({ open, onOpenChange, storeOpen }) => {
  const { list, subtotal, setQtyByKey } = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent data-testid="cart-sheet" className="flex w-full flex-col bg-[#0A0A0A] sm:max-w-md">
        <SheetHeader>
          <SheetTitle className="font-display text-2xl">Seu carrinho</SheetTitle>
        </SheetHeader>
        {list.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-3 text-slate-400">
            <ShoppingBag className="h-10 w-10" />
            <p data-testid="cart-empty">Seu carrinho está vazio</p>
          </div>
        ) : (
          <div className="flex-1 space-y-3 overflow-y-auto py-4">
            {list.map(({ key, product, qty, selections, unitPrice }) => (
              <div key={key} data-testid={`cart-item-${product.id}`} className="flex gap-3 rounded-xl border border-white/[0.08] bg-[#1A1A1A] p-3">
                {product.image_url && <img src={product.image_url} alt="" className="h-14 w-14 rounded-lg object-cover" />}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{product.name}</p>
                  {selections.length > 0 && (
                    <p className="text-xs text-slate-400">{selections.map((s) => `${s.qty}x ${s.option}${s.price ? ` (+${brl(s.price)})` : ""}`).join(", ")}</p>
                  )}
                  <p className="text-sm text-primo-400 font-semibold">{brl(unitPrice * qty)}</p>
                  <div className="mt-1 flex items-center gap-2">
                    <button data-testid={`cart-decrease-${product.id}`} onClick={() => setQtyByKey(key, qty - 1)} className="grid h-6 w-6 place-items-center rounded-full bg-white/10"><Minus className="h-3 w-3" /></button>
                    <span className="text-sm w-4 text-center">{qty}</span>
                    <button data-testid={`cart-increase-${product.id}`} onClick={() => setQtyByKey(key, qty + 1)} className="grid h-6 w-6 place-items-center rounded-full bg-primo-500 text-white"><Plus className="h-3 w-3" /></button>
                  </div>
                </div>
                <button data-testid={`cart-remove-${product.id}`} onClick={() => setQtyByKey(key, 0)} className="self-start text-slate-500 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
              </div>
            ))}
          </div>
        )}
        <div className="border-t border-white/[0.08] pt-4 space-y-3">
          <div className="flex justify-between text-lg">
            <span className="text-slate-400">Subtotal</span>
            <span data-testid="cart-subtotal" className="font-display font-bold">{brl(subtotal)}</span>
          </div>
          <button
            data-testid="cart-checkout-button"
            disabled={!list.length || !storeOpen}
            onClick={() => navigate("/checkout")}
            className="w-full rounded-full bg-primo-500 py-3.5 font-display font-bold text-white hover:bg-primo-400 active:scale-[0.98] transition-transform disabled:opacity-40"
          >
            {storeOpen ? "Finalizar pedido" : "Loja fechada no momento"}
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
